import * as Yup from 'yup';

const bundleCategorySchema = Yup.object().shape({
  labelEn: Yup.string().required('English Label is required.'),
  labelAr: Yup.string().required('Arabic Label is required.'),
  emoji: Yup.string().nullable().notRequired(),
  position: Yup.number()
    .min(1, 'Please enter more than 0')
    .typeError('Must be Number'),
});

export default bundleCategorySchema;
